import {Ref} from 'vue';

export const CheckZipcode = (options: object, variables: Ref<{ zipCode: string }>) => {
  const query = gql`
    query check_zipcode($zipCode: String = "", $date: timestamptz = "") {
      tbl_service_areas(where: {zipcodes: {zipcode: {_eq: $zipCode}}}) {
        id
        info_url
        location_id
        name
        video_url
        welcome_message
        welcome_title
        contact_phone
        contact_email
        question
        license_type_id
        licensed_location_id
        active
        toggle_active_date
        new_application_message
        tbl_translations {
          language_id
          translation_key
          translation_value
        }
        tbl_service_areas_languages {
          enabled
          language_id
        }
        zipcodes(where: {zipcode: {_eq: $zipCode}}) {
          license_type_id
          zipcode
        }
        fund_service_areas(where: {is_active: {_eq: true}, fund: {active: {_eq: true}}}) {
          fund {
            tbl_fund_assistance_types {
              tbl_assistance_type {
                name
                description
                category
                id
                assistance_type_locations {
                  translations
                  licensed_location_id
                }
              }
            }
            funding_source {
              name
              territory_id
            }
            active
          }
        }
        assis_type_config_array {
          config {
            active
          }
          assistance_type {
            category
            description
            id
            name
            assistance_type_locations {
              translations
              licensed_location_id
            }
          }
        }
      }
    }
  `;

  return useLazyQuery(query, variables, options);
};

export const CheckZipcodeByLicenseLocation = (options: object, variables: Ref<{ zipCode: string }>) => {
  const query = gql`
    query check_zipcode($zipCode: String = "", $licensed_location_id: Int, $license_type_id: Int = 10) {
      tbl_service_areas(where: {zipcodes: {zipcode: {_eq: $zipCode}}, licensed_location_id: {_eq: $licensed_location_id}, license_type_id: {_eq: $license_type_id}}) {
        id
        info_url
        location_id
        name
        video_url
        welcome_message
        welcome_title
        contact_phone
        contact_email
        question
        license_type_id
        licensed_location_id
        active
        toggle_active_date
        new_application_message
        tbl_translations {
          language_id
          translation_key
          translation_value
        }
        tbl_service_areas_languages {
          enabled
          language_id
        }
        zipcodes(where: {zipcode: {_eq: $zipCode}}) {
          license_type_id
          zipcode
        }
        fund_service_areas(where: {is_active: {_eq: true}, fund: {active: {_eq: true}}}) {
          fund {
            tbl_fund_assistance_types {
              tbl_assistance_type {
                name
                description
                category
                id
                assistance_type_locations {
                  translations
                  licensed_location_id
                }
              }
            }
            funding_source {
              name
              territory_id
            }
            active
          }
        }
        assis_type_config_array {
          config {
            active
          }
          assistance_type {
            category
            description
            id
            name
            assistance_type_locations {
              translations
              licensed_location_id
            }
          }
        }
      }
    }
  `;

  return useLazyQuery(query, variables, options);
};

export const getServiceAreaByAssistanceRequest = (options: object, variables: Ref<{ id: string }>) => {
  const query = gql`
    query get_service_area_by_assistance_request($id: uuid!) {
      tbl_service_areas(where: { tbl_applications: { id: { _eq: $id } } }) {
        id
        info_url
        location_id
        name
        video_url
        welcome_message
        welcome_title
        contact_phone
        contact_email
        question
        license_type_id
        fund_service_areas {
          fund {
            tbl_fund_assistance_types {
              tbl_assistance_type {
                name
                description
                category
                id
              }
            }
            funding_source {
              name
              territory_id
            }
          }
        }
        assis_type_config_array {
          config {
            active
          }
          assistance_type {
            category
            description
            id
            name
            assistance_type_locations {
              translations
              licensed_location_id
            }
          }
        }
      }
    }
  `;

  return useLazyQuery(query, variables, options);
};

export const GetZipcodeData = (options: object, variables: Ref<{ zipCode: string }>) => {
  const query = gql`
    query get_zipcode_data($zipCode: String = "") {
      getZipcodeData(arg1: { zipcode: $zipCode }) {
        success
        data {
          stateCode
          state
          id
          city
          zipcode
        }
      }
    }
  `;

  return useLazyQuery(query, variables, options);
};

export const GetServiceAreaById = (variables: { id: string }) => {
  const query = gql`
    query MyQuery($id: uuid = "") {
      tbl_service_areas_by_pk(id: $id) {
        contact_email
        contact_phone
        info_url
        license_type_id
        location_id
        name
        question
        updated_at
        video_url
        welcome_message
        welcome_title
      }
    }
  `;

  return useQuery(query, variables);
};

export const GetServiceAreaAssitanceType = (options: object) => {
  const query = gql`
    query assistance_type_fund_service_area($service_area_id: uuid!) {
      tbl_assistance_type_fund_service_area(
        where: { service_area_id: { _eq: $service_area_id } }
        order_by: { assistance_type: { display_order: asc } }
      ) {
        assistance_type {
          id
          name
        }
      }
    }
  `;

  return useLazyQuery(
    query,
    {
      service_area_id: '',
    },
    options
  );
};

export const ServiceAreaRestriction = (options: object) => {
  const query = gql`
    mutation MyMutation($zipcode: String = "") {
      checkSaRestriction(arg1: { zipcode: $zipcode }) {
        success
        data {
          id
          canAdd
          hasActiveNonEmptyFund
        }
      }
    }
  `;

  return useMutation(query, options);
};

export const ServiceAreaRestrictionById = (options: object) => {
  const query = gql`
    mutation MyMutation($id: String = "") {
      checkSaRestrictionById(arg1: { id: $id }) {
        data {
          canAdd
          id
          hasActiveNonEmptyFund
        }
        success
      }
    }
  `;

  return useMutation(query, options);
};
